import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Row, Col, Table } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField";
import { Formik } from "formik";
import "./CorporateProfile.styles.css";
import Axios from '../../lib/axios/axiosInstance';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { commonGet} from "../../services/auth";

const CorporateformSchema = Yup.object().shape({
  cName: Yup.string().min(2).required("Compny name is required"),
  uenno: Yup.string().min(2).max(25).required("UEN No. is required"),
  // email: Yup.string().email("Email is invalid").required("Email is required"),
  addr1: Yup.string().max(150,"Maximum length is 150").required("Address is required"),
  addr2: Yup.string(),//.required("Address is required"),
  // city: Yup.string().required("City is required"),
  zipCode: Yup.number().required("Please enter your zip/postal code"),
  country: Yup.string().required("Country is required"),
  state: Yup.string(),//.required("State is required"),
  city: Yup.string(),//.required("City is required"),
  website: Yup.string().required("Website is required"),
  contactNo: Yup.string().min(8, "Contact number must be of 8 digits").required("Please enter your contact number"),
});

const CorporateProfile = () => {
  const [initialValue, setInitialValue] = useState({
    email: "",
    cName: "",
    gender: "",
    dob: "",
    addr1: "",
    city: "",
    zipCode: "",
    state: "",
    country: "",
    contactNo: "",
    website: "",
  });

  const [logedInUser, setLogedInUser] = useState(false);
  const [acccountDetails, setacccountDetails] = useState(false);

  const getAccountDetails= async (arnum, role) => {
    var result=[];
    await Axios.get('/profile/corpprofile?arnum='+arnum)
    .then(function (response) {
    if(response.data && response.data.profile){
      response.data.profile.role=role;
      setacccountDetails(response.data.profile);
    }else{
      toast.error('Profile data fetching failed !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      });
      return false;
    }})
    .catch(function (error) {
      setacccountDetails(false);
    });
  };
  
  useEffect(() => {
    const user=AuthVerify.getUser();
    if(user && user.role){
      getAccountDetails(user.arnum,user.role);
      setLogedInUser(user.role);
    }
  }, [])

  useEffect(() => {

    setInitialValue({
        arnum: acccountDetails.arnum??'',
        cName: acccountDetails.arname??'',
        uenno: acccountDetails.uenno??'',
        addr1: acccountDetails.addr1??'',
        addr2: acccountDetails.addr2??'',
        addr3: acccountDetails.addr3??'',
        zipCode: acccountDetails.postcode??'',
        contactNo: acccountDetails.phone??'',
        email: acccountDetails.email??'',
        website: acccountDetails.website??'',
        country: acccountDetails.country??'',
        state: acccountDetails.state??'',
        city: acccountDetails.city??''
    });
    setCountryValue(acccountDetails?.country);
    setStateValue(acccountDetails?.state);
    setCityValue(acccountDetails?.city);
  }, [acccountDetails])
  
  const updateFormSubmitHandler = async (values) => {
    var val = {
      profile:{
        arnum: values.arnum,
        arname: values.cName,
        uenno: values.uenno,
        addr1: values.addr1,
        addr2: values.addr2,
        addr3: values.addr3,
        postcode: values.zipCode,
        phone: values.contactNo,
        email: values.email,
        website: values.website,
        country: values.country,
        state: values.state,
        city: values.city
      }
    }
    await Axios.post('/profile/corpprofile/update',val)
    .then(function (response) {
      if (response && response.status == 200 && response.data.profile!=null) {
        toast.success('Profile updated successfully.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
  };
  toast.configure();

  
  //--------------------------------
  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [defaultValue, setDefaultValue] = useState(true);

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`,true);
    var dd=[];
    setAllCountries(allCountries.data.countryList);
    allCountries.data.countryList.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCountries(dd);
  };

  async function handleCountryChange(event){
    var result=allCountries.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    if(result.subgrp && result.subgrp.length>0){
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varname})
     });
    }
    setStates(dd);
    setCities([]);
    setCountryValue(countries.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allStates.filter(x=>x.grp.varname==event.target.value)[0];
    var dd=[];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value:  element.grp.varname})
    });
    setCities(dd);
    setStateValue(states.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value==event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
  }, [])

  useEffect(async () => {
    if(countryValue && defaultValue && allCountries.length>0){
      handleCountryChange({target:{value:countryValue}});
    }
  }, [allCountries,countryValue])

  useEffect(async () => {
    if(stateValue && defaultValue && allStates.length>0){
      handleStateChange({target:{value:stateValue}});
      setDefaultValue(false);
    }
  }, [allStates,stateValue])
  //--------------------------------

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Corporate Profile</h2>
        </div>
        <div className="dashboard">
          <div className="welcome-msg">

            <h4>Manage Company Profile</h4>
            <p>
              Please ensure your details are complete and accurate. Your profile
              details will be used as your default billing information on
              checkout process.
            </p>
          </div>
          <hr />
          <div className="page-content checkout-page">
            <h3 className="checkout-sep">Company Information</h3>
            <div className="box-border">
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformSchema}
                onSubmit={(values, { setSubmitting }) => {
                  // console.log(values);
                  updateFormSubmitHandler(values);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Col xl={12} sm={12} xs={12}>
                      <Row>
                        <Col xl={6} sm={6}>
                          <InputField
                            Name="cName"
                            id="cName"
                            Labels="Company Name"
                            Type="text"
                            value={values.cName}
                            onChange={handleChange}
                            isInvalid={!!errors.cName}
                            className={(errors.cName && touched.cName) ? 'is-invalid' : 'form-control'}
                          />
                        </Col>

                        <Col xl={6} sm={6}>
                          <InputField
                            Name="uenno"
                            id="uenno"
                            Labels="UEN No."
                            Type="text"
                            value={values.uenno}
                            onChange={handleChange}
                            isInvalid={!!errors.uenno}
                            className={(errors.uenno && touched.uenno) ? 'is-invalid' : 'form-control'}
                          />
                        </Col>
                        </Row>
                        </Col>
                        <Col xl={12} sm={12} xs={12}>
                      <Row>
                          <br />
                        <Col xl={12} sm={12}>
                          <h5 style={{ color: "#333333", fontWeight: "600" }}>
                            Billing Details
                          </h5>
                          <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="addr1"
                                id="addr1"
                                Labels="Address 1"
                                Type="text"
                                value={values.addr1}
                                onChange={handleChange}
                                isInvalid={!!errors.addr1}
                                className={(errors.addr1 && touched.addr1) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                        <Col xl={6} sm={6}>
                                <InputField
                                  Name="addr2"
                                  id="addr2"
                                  Labels="Address 2"
                                  Type="text"
                                  value={values.addr2}
                                  onChange={handleChange}
                                  isInvalid={!!errors.addr2}
                                  className={(errors.addr2 && touched.addr2) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                          </Row>
                        </Col>
                        
                        <Col xl={12} sm={12} xs={12}>
                          <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="addr3"
                                id="addr3"
                                Labels="Address 3"
                                Type="text"
                                value={values.addr3}
                                onChange={handleChange}
                                isInvalid={!!errors.addr3}
                                className={(errors.addr3 && touched.addr3) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                              {/* <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="Country"
                                    Name="country"
                                    placeHolder="Select Your Country"
                                    options={countries}
                                    value={values.country}
                                    onChange={e=>{values.state=""; setStates([]); values.city=""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.country && touched.country
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col> */}
                              {/* <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="State/Province"
                                    Type="text"
                                    Name="state"
                                    placeHolder="Select Your State"
                                    options={states}
                                    value={values.state}
                                    onChange={e=>{handleStateChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.state && touched.state
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col> */}
                              <Col xl={6} sm={6}>
                              <InputField
                                Name="zipCode"
                                id="address"
                                Labels="Postal Code"
                                Type="number"
                                value={values.zipCode}
                                onChange={handleChange}
                                isInvalid={!!errors.zipCode}
                                className={(errors.zipCode && touched.zipCode) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                              </Row>
                          </Col>
                          {/* <Col xl={12} sm={12} xs={12}>
                          <Row>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    Labels="City"
                                    Type="text"
                                    Name="city"
                                    placeHolder="Select Your City"
                                    value={values.city}
                                    onChange={e=>{handleCityChange(e); handleChange(e);}}
                                    onBlur={handleBlur}
                                    options={cities}
                                    className={
                                      errors.city && touched.city
                                        ? " is-invalid"
                                        : ""
                                    }
                                  />
                                </div>
                              </Col>
                            
                            </Row>
                          </Col> */}
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="contactNo"
                                id="contactNo"
                                Labels="Contact No."
                                Type="text"
                                value={values.contactNo}
                                onChange={handleChange}
                                isInvalid={!!errors.contactNo}
                                className={(errors.contactNo && touched.contactNo) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>

                        {/* <Col xl={6} sm={6}>
                          <InputField
                            Name="email"
                            id="email"
                            Labels="Email"
                            Type="text"
                            value={values.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                          />
                        </Col> */}

                        <Col xl={6} sm={6}>
                          <InputField
                            Name="email"
                            id="email"
                            Labels="Email"
                            Type="text"
                            value={values.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                          />
                        </Col>

                        {/* <Col xl={12} sm={12}>
                          <hr />
                          <Row>
                            <Col xl={6} sm={6}>
                              <InputField
                                Name="acra"
                                id="acra"
                                Labels="Upload ACRA (Optional) Get $5 Voucher!"
                                Type="text"
                                value={values.acra}
                                onChange={handleChange}
                                isInvalid={!!errors.acra}
                                className={(errors.acra && touched.acra) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xl={12} sm={12}>
                          <button type="submit" className="button">
                            Update Profile
                          </button>
                        </Col> */}
                      </Row>
                    </Col>
                  </form>
                )}
              </Formik>
            </div>

            <div className="col-main">
              <div className="my-account">
                {/* <div className="page-title">
                  <h3
                    className="checkout-sep"
                    style={{ marginTop: "0", padding: "12px 0 12px 0" }}
                  >
                    Document Information
                  </h3>
                </div> */}
                {/* <div className="dashboard">
                  <div className="toolbar">
                    <Row>
                      <Col md={3} sm={3} xl={3}
                        style={{ display: "flex" }}
                      >
                        <input
                          type="text"
                          name=""
                          id="first_name_1"
                          placeholder="Keywords search..."
                          style={{ borderRadius: "3px 0 0 3px", margin: 0, }}
                        />
                        <button
                          type="submit"
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "0 3px 3px 0",
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </Col>
                      <Col md={3} sm={3} xl={12}></Col>
                      <Col md={2} sm={2} xl={2}></Col>

                      <Col md={1} sm={1} xl={1} className="col-sm-1 text-right"></Col>
                      <Col md={3} sm={3} xl={12} className="text-right">
                        <Link to="/my-account#corporateprofile">+ Add New Document </Link>
                      </Col>
                    </Row>
                  </div>
                  <div className="recent-orders">
                    <Table bordered responsive hover>
                      <thead>
                        <tr className="first last">
                          <th>Document Name</th>
                          <th>Document Type</th>
                          <th>Submitted Date</th>
                          <th>Status</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="first odd">
                          <td>Sample Name</td>
                          <td>Sample Type</td>
                          <td>01 Nov 2021</td>
                          <td>
                            <em>New</em>
                          </td>
                          <td className="a-center last">
                            <span className="nobr">
                              <Link to="/my-account#corporateprofile">Delete</Link>
                              <span className="separator">|</span>
                              <Link to="/my-account#corporateprofile">Edit</Link>
                            </span>
                          </td>
                        </tr>
                        <tr className="last even">
                          <td>Sample Name</td>
                          <td>Sample Type</td>
                          <td>01 Nov 2021</td>
                          <td>
                            <em>Verified</em>
                          </td>
                          <td className="a-center last"></td>
                        </tr>
                        <tr className="first odd">
                          <td>Sample Name</td>
                          <td>Sample Type</td>
                          <td>01 Nov 2021</td>
                          <td>
                            <em>Rejected</em>
                          </td>
                          <td className="a-center last">
                            <span className="nobr">
                              <Link to="/my-account#corporateprofile">Edit</Link>
                            </span>
                          </td>
                        </tr>
                        <tr className="last even">
                          <td>Sample Name</td>
                          <td>Sample Type</td>
                          <td>01 Nov 2021</td>
                          <td>
                            <em>Void</em>
                          </td>
                          <td className="a-center last">
                            <span className="nobr">
                              <Link to="/my-account#corporateprofile">Edit</Link>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateProfile;
